import { useGameStore } from '../store/gameStore';
import { audioManager } from '../audio/AudioManager';

/**
 * NowPlayingBar — shows currently audible track.
 * Fades in/out based on proximity crossfadeLevel.
 * Positioned at the bottom of the screen.
 */
export default function NowPlayingBar() {
  const activeTrackId = useGameStore((s) => s.activeTrackId);
  const crossfadeLevel = useGameStore((s) => s.crossfadeLevel);

  const track = activeTrackId ? audioManager.getTrack(activeTrackId) : null;

  if (!track || crossfadeLevel < 0.05) {
    return null;
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 p-4 pointer-events-none transition-opacity duration-300"
      style={{ opacity: crossfadeLevel }}
    >
      <div className="max-w-md mx-auto bg-black/60 backdrop-blur-lg rounded-2xl p-4 text-white border border-white/10 shadow-2xl">
        <div className="flex items-center gap-3">
          {/* Album art thumbnail */}
          <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0 bg-white/10">
            <img
              src={track.albumArt}
              alt={track.title}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          {/* Track info */}
          <div className="flex-1 min-w-0">
            <p className="font-display font-bold text-sm truncate">{track.title}</p>
            <p className="text-xs text-white/60 truncate">{track.artist}</p>
          </div>

          {/* Play indicator */}
          <div className="flex-shrink-0 flex items-center gap-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="w-1 bg-festival-gold rounded-full animate-pulse"
                style={{
                  height: `${8 + Math.random() * 12}px`,
                  animationDelay: `${i * 0.15}s`,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
